// extracted by mini-css-extract-plugin
export default {"Label":"Label_Label__nAFYi","light":"Label_light__ra-YN","text":"Label_text__NaDBn","dark":"Label_dark__K-+2X"};